import React from 'react';
import styled from 'styled-components';
import { Wrapper } from './DataCard';

const Button = styled.button.withConfig({
  shouldForwardProp: (prop) => prop !== 'active', // sprječava prosljeđivanje 'active' u DOM
})`
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  background-color: ${({ active, theme }) =>
    active ? theme.colors.primary : theme.colors.buttonBackground};
  color: ${({ active, theme }) =>
    active ? theme.colors.buttonTextActive : theme.colors.buttonText};
  &:hover {
    opacity: 0.8;
  }
  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

const Ellipsis = styled.span`
  padding: 0.5rem 1rem;
`;

function Pagination({ currentPage, totalPages, onPageChange }) {
  if (totalPages <= 1) return null;

  const pages = [];
  pages.push(0);
  if (currentPage > 2) pages.push("...");
  for (let i = currentPage - 1; i <= currentPage + 1; i++) {
    if (i > 0 && i < totalPages - 1) pages.push(i);
  }
  if (currentPage < totalPages - 3) pages.push("...");
  if (totalPages > 1) pages.push(totalPages - 1);

  return (
    <Wrapper style={{ gap: "8px" }}>
      <Button
        onClick={() => onPageChange(Math.max(currentPage - 1, 0))}
        disabled={currentPage === 0}
      >
        ←
      </Button>

      {pages.map((page, index) =>
        page === "..." ? (
          <Ellipsis key={`ellipsis-${index}`}>...</Ellipsis>
        ) : (
          <Button
            key={page}
            active={page === currentPage}
            onClick={() => onPageChange(page)}
          >
            {page + 1}
          </Button>
        )
      )}

      <Button
        onClick={() => onPageChange(Math.min(currentPage + 1, totalPages - 1))}
        disabled={currentPage === totalPages - 1}
      >
        →
      </Button>
    </Wrapper>
  );
}

export default Pagination;
